import { Component, Inject, OnInit } from '@angular/core';

import { Paginacao } from '@app/models/util/paginacao';

import { PeticaoTese } from '@app/models/peticao-tese.model';
import { PeticaoTeseService } from '@app/services/peticao-tese.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-peticao-tese-lista',
  templateUrl: './peticao-tese-lista.component.html'
})
export class PeticaoTeseListaComponent implements OnInit {

  lstTeses: PeticaoTese[] = [];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;


  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private peticaoTeseService: PeticaoTeseService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }


  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.peticaoTeseService.obterLista(descricao, pagina)
      .subscribe(data => {
        this.lstTeses = data.Dados,
          this.paginacao.totalDeItens = data.Total
      }, erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(peticaoTese: PeticaoTese) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a tese: " + peticaoTese.Descricao;
    this.bsModalRef.content.confirmar = () => {
      this.peticaoTeseService.deletar(peticaoTese.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }

  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
